import { FC, useEffect } from 'react'
import * as atoms from 'src/v2/state/owner-reveal/activity-heatmap'

import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ActivityHeatmapContent } from 'src/v2/views/owner-reveal/insights/owner-summary/activity-heatmap/content'
import { useSetAtom } from 'jotai'

export const ActivityHeatmap: FC = () => {
  const setSelectedState = useSetAtom(atoms.selectedStateCode)

  useEffect(() => {
    return () => {
      setSelectedState(undefined)
    }
  }, [])

  return (
    <WidgetCard
      id="activity-heatmap"
      title="Activity Heatmap"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      // filters={<ActivityHeatmapFilters />} // TODO: Implement filters when data is ready
      sections={[
        {
          content: <ActivityHeatmapContent />,
        },
      ]}
    />
  )
}
